<template lang="pug">
	b-button(@click="takePart" type="button" variant="success" :disabled="_disabled") Зарегистрироваться
</template>
<script>

export default {
	name: 'regBtn',
	props: ['_event','_disabled'],
	methods: {
		takePart(){
			this._event.extra_data.length
				? this.$bvModal.show(`ExtraDataModal-${this._event.id}`)
				: this.$bvModal.show(`NoExtraDataModal-${this._event.id}`);
		}
	},
};
</script>

